<template>
  <div class="list-download-container">
    <div
      v-if="showCancelButton"
      class="is-flex is-justify-content-flex-end flex-1 has-background-gray-lightest"
    >
      <span class="is-clickable mr-10" @click="downloadCancel()">
        {{ General.CANCEL_ALL.toUpperCase() }}
      </span>
    </div>
    <ul>
      <template v-if="$slots.list">
        <slot :props="i" class="item" />
      </template>
      <li
        v-for="(file, index) in getListDownloadFiles"
        :key="index"
        class="item"
      >
        <span class="py-10">{{ file.name }}</span>
        <template v-if="file.status === 'pending'">
          <div class="change-action">
            <div>
              <CircleLoading :percentage="file.percentage" :endless="true" />
            </div>
            <span class="is-clickable" @click="downloadCancel(file.file_index)">
              <b-icon icon="close-circle" />
            </span>
          </div>
        </template>
        <template v-else-if="file.status === 'done'">
          <span class="is-clickable" @click.stop="file.download">
            <b-icon icon="download-circle" />
          </span>
        </template>
        <template v-else-if="file.status === 'abort'">
          {{ General.CANCELED_PROCESS }}
          <b-icon icon="alert-circle" type="is-danger" />
        </template>
        <template v-else-if="file.status === 'error'">
          <b-icon icon="close-circle" type="is-danger" />
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { General } from "@/utils/constants";
import CircleLoading from "@/components/CircleLoading";

export default {
  name: "ListDownloadFiles",
  components: {
    CircleLoading
  },
  data() {
    return {
      General,
      isLoading: false
    };
  },

  computed: {
    ...mapGetters({
      getListDownloadFiles: "getListDownloadFiles"
    }),

    showCancelButton() {
      return this.getListDownloadFiles.some(
        file => !file.isErro && file.status === "pending"
      );
    }
  },

  watch: {
    getListDownloadFiles: {
      handler() {
        this.setTitle();
      },
      deep: true
    }
  },

  beforeMount() {
    this.setTitle();
  },

  methods: {
    ...mapActions({
      setCancelDownloadFile: "setCancelDownloadFile"
    }),

    downloadCancel(fileIndex = -1) {
      this.setCancelDownloadFile(fileIndex);
    },

    setTitle() {
      const countFiles = this.getListDownloadFiles.filter(
        file => file.status === "pending"
      ).length;
      let newTitle = this.General.TEXTS.DOWNLOAD_FINISHED;
      if (countFiles) {
        const mensage =
          countFiles === 1
            ? this.General.TEXTS.DOWNLOAD_QUANTITY_SINGULAR
            : this.General.TEXTS.DOWNLOAD_QUANTITY;
        newTitle = mensage.replace("(QUANTITY)", countFiles);
      }
      this.$emit("updateTitle", newTitle);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.list-download-container {
  display: flex;
  flex-direction: column;
  max-height: 30vh;
  width: 350px;
  @media screen and (max-width: $tablet) {
    width: auto;
  }
  background-color: #ffffff;

  ul {
    overflow-y: auto;
  }

  .item {
    margin: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.6rem;
    &:not(:last-child) {
      border-bottom: 1px solid $border-color;
    }
    :first-child {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    :last-child {
      display: flex;
      align-items: center;
    }

    .change-action {
      > div {
        display: block;
      }
      > span {
        display: none;
      }

      &:hover {
        > div {
          display: none;
        }
        > span {
          display: block;
        }
      }
    }
  }
}
</style>
